import { Typography } from "@mui/material";

function SectionsSecondaryHeading({ children, color = "#0E0B33", py = "" }) {
  return (
    <Typography
      sx={{
        fontSize: "18px",
        lineHeight: "26px",
        fontFamily: "Inter",
        fontWeight: "400",
        color: color,
        maxWidth: "790px",
        textAlign: "center",
        py: py,
      }}
    >
      {children}
    </Typography>
  );
}

export default SectionsSecondaryHeading;
